import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "checkbox" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Ellipsis = _resolveComponent("Ellipsis")
  const _component_el_checkbox = _resolveComponent("el-checkbox")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_checkbox, {
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.value) = $event)),
      class: "checkbox-el",
      size: $props.size,
      value: $props.checkedValue,
      indeterminate: $props.indeterminate
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Ellipsis, {
          class: "checkbox-text",
          teleported: ""
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ]),
          _: 3 /* FORWARDED */
        })
      ]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["modelValue", "size", "value", "indeterminate"])
  ]))
}